import React from 'react';
import { Icon } from './Icon.js';
export const IconMediaSkipToEnd = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M11 12L3 5V19L11 12Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M21.5 12L13.5 5V19L21.5 12Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconMediaSkipToEnd.js.map